var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-container"},[_c('div',{staticClass:"page-body"},[_c('div',{staticClass:"page-img"},[_c('img',{attrs:{"src":require("@/assets/ml-logo.png")}})]),_vm._v(" 欢迎使用过磅系统！ ")])])
}]

export { render, staticRenderFns }